import * as React from 'react';
import classNames from 'classnames';
const Group = (props) => {
    const { prefixCls = 'ui-input-group', className = '' } = props;
    const cls = classNames(prefixCls, {
        [`${prefixCls}_lg`]: props.size === 'large',
        [`${prefixCls}_sm`]: props.size === 'small',
        [`${prefixCls}_compact`]: props.compact,
    }, className);
    return (<span className={cls} style={props.style}>
      {props.children}
    </span>);
};
export default Group;



// WEBPACK FOOTER //
// ./components/input/Group.tsx